import { Component, inject, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticatedUser, AuthenticationService, ConnectApiClientService } from '@aveva/connect-web-core';
import { AuthorizationError } from './authorization-error';

@Component({
  standalone: false,
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent implements OnInit {
  private readonly connectApiClient = inject(ConnectApiClientService);
  private readonly authenticationService = inject(AuthenticationService);
  private readonly route = inject(ActivatedRoute);

  authorizationError: AuthorizationError;
  authenticatedUser?: AuthenticatedUser;
  authenticatedUserAccount?: any;

  constructor() {
    const errorCode = this.route.snapshot.params['errorCode'];
    this.authorizationError = AuthorizationError.parse(errorCode);
  }

  async ngOnInit(): Promise<void> {

    // Get user
    this.authenticatedUser = await this.authenticationService.getUser();

    // Get user account
    this.authenticatedUserAccount = await this.connectApiClient.accountManagement.getAccount(this.authenticatedUser.account);
  }

  public async signout(): Promise<void> {
    await this.authenticationService.signout();
  }
}
